import { DataFieldConfig } from './data-builder';

export const surroundingFields: DataFieldConfig[] = [
  {
    key: 'surrounding.generalAboutArea',
    label: 'Allmänt om området',
    source: 'provider',
  },
  {
    key: 'surrounding.nearService',
    label: 'Serviceutbud',
    source: 'provider',
  },
  {
    key: 'surrounding.communication',
    label: 'Kommunikation',
    source: 'provider',
  },
  {
    key: 'surrounding.parking',
    label: 'Parkering',
    source: 'provider',
  },
  {
    key: 'surrounding.other',
    label: 'Övrigt',
    source: 'provider',
  },
];
